<rds-breadcrumbs class="breadcrumbs" [appStoryblok]="_editable" size="l" [items]="items()" (itemClick)="navigate($event)"></rds-breadcrumbs>

